import { render, staticRenderFns } from "./InputPhoto.vue?vue&type=template&id=4847eb9a&"
import script from "./InputPhoto.vue?vue&type=script&lang=js&"
export * from "./InputPhoto.vue?vue&type=script&lang=js&"
import style0 from "./InputPhoto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports